import React from "react";
import BusinessCard from "./businessCard";
import { elakay_API } from "../../config";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["invitationBusinessCard"]?.[key] || fallback;

// Shared, collapsed-by-default "invitation card" reveal (QR code + business
// card) -- driven entirely by the `show` prop so the caller (ActivationLinkActions)
// owns the toggle. Used identically wherever an activation link's QR code
// needs to be shown (CardUser's modal, addAdminFamily's success card) --
// never renders automatically, never the only place the QR is generated
// (mission: "ne pas afficher automatiquement la grande BusinessCard").
const InvitationBusinessCard = ({ show, infoSource, userInfo, fullName, roleName, activationUrl, expirationDate }) => {
  __setElakayInfoSource(infoSource);
  if (!show || !activationUrl) return null;

  return (
    <div className="activation-invitation-card">
      {expirationDate && (
        <p className="activation-invitation-card-expiry">
          {__elakayText("expiresOn", "Expires on")} {new Date(expirationDate).toLocaleDateString()}
        </p>
      )}
      <BusinessCard
        infoSource={infoSource}
        userInfo={userInfo}
        logo={`${elakay_API}/icon/logo_elakay/elakay_logo.png`}
        companyName="Elakay"
        fullName={fullName}
        role={roleName}
        qrValue={activationUrl}
        barcodeValue={userInfo?.publicId || ""}
      />
    </div>
  );
};

export default InvitationBusinessCard;
